import React, { useState } from 'react';
import { EbuiltInfoCardStyles } from './EbuiltInfoCard.styled';
import PropTypes from 'prop-types';
import ChevronUpSvg from 'pubweb-smokey/dist/images/svg/iconography-16x16/chevron-up.svg';
import ChevronDwnSvg from 'pubweb-smokey/dist/images/svg/iconography-16x16/chevron-dwn.svg';
import MoneyCircle from './images/money-circle.svg';
import Window from './images/window.svg';
import Thermometer from './images/thermometer.svg';
import Snowflake from './images/snowflake.svg';
import Home from './images/home.svg';

const EbuiltInfoCard = ({ ModelName }) => {
  const [isOpen, SetIsOpen] = useState(false);
  const onShowMoreClick = () => {
    SetIsOpen(!isOpen);
  };

  const modelContainsThe = ModelName.toLowerCase().startsWith('the');

  return (
    <EbuiltInfoCardStyles>
      <div className="ebuilt-info-container">
        <div className="ebuilt-info-header-content">
          <MoneyCircle />
          <h3>
            {`See How ${modelContainsThe ? ModelName : 'The ' + ModelName} can
            Save You Up to 50%** on Annual Energy Bills`}
          </h3>
          <p>
            Many of our homes come with energy-efficient enhancements that can
            reduce your energy bills. Ask your Home Center about purchasing an
            eBuilt® home.
          </p>
        </div>
        {isOpen && (
          <div className="ebuilt-info-content">
            <div className="efficiency-item">
              <Window className="icon" />
              <div className="efficiency-text">
                <h4>Lux® Low-E argon gas windows</h4>
                <p>
                  Help block UV rays and keep your home at a comfortable
                  temperature
                </p>
              </div>
            </div>
            <div className="efficiency-item flex-end">
              <Thermometer className="icon" />
              <div className="efficiency-text">
                <h4>ecobee® smart thermostats</h4>
                <p>
                  Regulate the temperature of your home throughout the day while
                  also using less energy
                </p>
              </div>
            </div>
            <div className="efficiency-item">
              <Home className="icon" />
              <div className="efficiency-text">
                <h4>Insulation</h4>
                <p>
                  Improves the thermal performance of your home with quality
                  insulation in the roof cavity, subflooring and walls
                </p>
              </div>
            </div>

            <div className="efficiency-item flex-end">
              <Snowflake className="icon" />
              <div className="efficiency-text">
                <h4>Carrier SmartComfort® heat pumps</h4>
                <p>
                  Provides industry-leading dependability, efficiency and
                  year-round comfort you can count on
                </p>
              </div>
            </div>
          </div>
        )}
        <a className="control-box" onClick={() => onShowMoreClick()}>
          <p>{isOpen ? 'Hide' : 'Discover eBuilt®'}</p>
          {isOpen ? (
            <ChevronUpSvg className="chev up" />
          ) : (
            <ChevronDwnSvg className="chev" />
          )}
        </a>
      </div>
    </EbuiltInfoCardStyles>
  );
};

export default EbuiltInfoCard;

EbuiltInfoCard.propTypes = {
  ModelName: PropTypes.string.isRequired,
};
